import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d6587c60"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "z-upload" }
const _hoisted_2 = { class: "z-upload__text" }
const _hoisted_3 = { class: "z-upload__title" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "z-upload__button" }, [
  /*#__PURE__*/_createElementVNode("span", null, "选择文件")
], -1))
const _hoisted_5 = {
  key: 0,
  class: "z-upload__info"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 简历文件控制在20M以内，仅支持pdf、doc、docx、html、png、jpg格式文件 ")
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 上传成功后，系统可以自动解析并填充 ")
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = {
  key: 1,
  class: "z-upload__info"
}
const _hoisted_11 = {
  key: 1,
  class: "z-upload__wrap"
}
const _hoisted_12 = { class: "el-upload-dragger" }
const _hoisted_13 = { class: "z-upload__text" }
const _hoisted_14 = { class: "z-upload__title" }
const _hoisted_15 = {
  key: 0,
  class: "z-upload__info"
}
const _hoisted_16 = {
  key: 1,
  class: "z-upload__button"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.fileList.length == 0)
      ? (_openBlock(), _createBlock(_component_el_upload, {
          key: 0,
          class: "z-upload__wrap",
          action: "",
          "file-list": _ctx.fileList,
          "on-exceed": _ctx.handleExceed,
          "before-upload": _ctx.beforeUpload,
          "http-request": _ctx.getUploadToken,
          limit: 1,
          drag: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.fileType === 'resume' ? `将您的简历拖拽至此区域自动解析` : '将您的文件拖拽至此区域'), 1),
              _hoisted_4,
              (_ctx.fileType === 'resume')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, _hoisted_9))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, "上传文件控制在20M以内"))
            ])
          ]),
          _: 1
        }, 8, ["file-list", "on-exceed", "before-upload", "http-request"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.fileList[0] && _ctx.fileList[0].name ? _ctx.fileList[0].name : '文件'), 1),
              (_ctx.fileList[0] && _ctx.fileList[0].gmtCreate)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, " 上传时间：" + _toDisplayString(_ctx.fileList[0].gmtCreate), 1))
                : _createCommentVNode("", true),
              (_ctx.fileType === 'resume')
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("span", {
                      class: "primary",
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileParse && _ctx.handleFileParse(...args)))
                    }, "解析")
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: "z-upload__remove",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleFileRemove && _ctx.handleFileRemove(...args)))
              }, "删除文件")
            ])
          ])
        ]))
  ]))
}